export const BASE_URL="https://admin.liter.live/api/";
export const LITER_API_BASE_URL = "https://api.liter.live/api/";
export const LITER_BASE_URL = "https://app.liter.live/";

export const AUTH_BASE_URL="https://authworld.liter.live";
export const APPLICATION_ID= 3;
export const CLIENT_ID = "liter_admin_ui-zdxylrl7nsl7tnkbshlbyixdwx3wmi0c"; // Replace with your actual client ID
export const REDIRECT_URI = `${window.location.origin}/silent-callback.html`; //

//uncomment to work locally 
// export const BASE_URL="http://localhost:8000/api/";
// export const LITER_API_BASE_URL = "http://localhost:8001/api/";
// export const LITER_BASE_URL = "http://localhost:3001/";


// export const AUTH_BASE_URL="http://localhost:9595";
// export const APPLICATION_ID= 3;
// export const CLIENT_ID = "liter_admin_laravel-jn9whtairis3b782xpup3l71q9dapycr"; // Replace with your actual client ID
// export const REDIRECT_URI = `${window.location.origin}/silent-callback.html`; // Must match the redirect URI registered in your OAuth provider